import "./home.css";

import React from "react";
import { Link } from "react-router-dom";

import { HOME, ROUTES } from "../../data/content";
import PageMeta from "../general/PageMeta";
import Parallax from "../general/Parallax";
import TeamCarousel from "./TeamCarousel";

//Reproduces the original Wix home page: full-width sections (three with parallax photos) and the content placed on Wix's
//980px centred grid at the same positions & sizes (see home.css). Below 1000px wide it switches to a stacked layout
const Home = () => {
  return (
    <div className={"home"}>
      <PageMeta title={"Home"} />

      {/* Brick wall with the Discovery / about U logos */}
      <Parallax
        as={"section"}
        className={"home-hero"}
        src={"/images/home/hero-1200.jpg"}
        srcSet={"/images/home/hero-900.webp 900w, /images/home/hero-1407.webp 1407w"}
        alt={"Discovery and about U logos on a white brick wall"}
      >
        <div className={"home-grid home-hero-buttons"}>
          <Link
            to={ROUTES.SERVICES}
            className={"btn home-btn home-hero-btn"}
          >
            Our Services
          </Link>
          <Link
            to={ROUTES.CONTACT}
            className={"btn home-btn home-hero-btn"}
          >
            Contact Us
          </Link>
        </div>
      </Parallax>

      <section className={"home-intro"}>
        <div className={"home-grid"}>
          <div className={"home-intro-text"}>
            <h1 className={"home-intro-title"}>{HOME.HEADING}</h1>
            <p className={"home-intro-sub"}>{HOME.SUBHEADING}</p>
            <span className={"home-rule home-intro-rule"} />
            <Link
              to={ROUTES.SERVICES}
              className={"btn home-btn home-intro-btn"}
            >
              Our Services
            </Link>
          </div>
          <div
            className={"home-intro-photos"}
            aria-hidden={"true"}
          >
            <img
              src={"/images/home/meeting-1.webp"}
              alt={""}
              className={"home-intro-photo is-back"}
              width={506}
              height={506}
            />
            <img
              src={"/images/home/meeting-2.webp"}
              alt={""}
              className={"home-intro-photo is-front"}
              width={506}
              height={506}
            />
          </div>
          {/* Hangs over the top of the team photo below, as on the original */}
          <img
            src={"/images/home/lines.png"}
            alt={""}
            className={"home-intro-lines"}
            width={505}
            height={697}
            aria-hidden={"true"}
          />
        </div>
      </section>

      {/* The whole photo links to the team page, as on the original */}
      <Parallax
        as={Link}
        to={ROUTES.TEAM}
        className={"home-band home-band-team"}
        src={"/images/home/team-group-1920.webp"}
        srcSet={"/images/home/team-group-1920.webp 1920w, /images/home/team-group-2880.webp 2880w"}
        alt={"The about U team - meet the team"}
        position={"center top"}
      />

      <section className={"home-about"}>
        <div className={"home-grid"}>
          <h2 className={"home-title home-about-title"}>{HOME.ABOUT_HEADING}</h2>
          <span className={"home-rule home-about-rule"} />
          <p className={"home-about-text"}>{HOME.ABOUT}</p>
        </div>
      </section>

      <Parallax
        className={"home-band home-band-website"}
        src={"/images/home/website.webp"}
        aria-hidden={"true"}
      />

      <section className={"home-team"}>
        <div className={"home-grid home-team-header"}>
          <h2 className={"home-title home-team-title"}>{HOME.TEAM_HEADING}</h2>
          <span className={"home-rule home-team-rule"} />
          <Link
            to={ROUTES.TEAM}
            className={"btn home-btn home-team-btn"}
          >
            Meet the team
          </Link>
        </div>
        <TeamCarousel />
      </section>
    </div>
  );
};

export default Home;
